import { useStaticQuery, graphql } from "gatsby"

export const useHomeHeroQuery = () => {
  const { secondaryHeroImage, heroVideo } = useStaticQuery(
    graphql`
      query HomeHeroQuery {
        secondaryHeroImage: wp {
          acfOptionsCommonItems {
            commonItems {
              commonItemsSecondaryHeroImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              commonItemsSecondaryHeroImageAltText
            }
          }
        }
        heroVideo: wpPage(title: { eq: "Home" }) {
          herovideo {
            heroVideoBackgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            heroVideoTextColored
            heroVideoTextWhite
            heroVideoButton {
              title
              url
            }
            heroVideoPlayButton {
              localFile {
                childSvg {
                  content {
                    data
                  }
                }
              }
            }
            heroVideoBackgroundVideoUrl {
              url
            }
            heroVideoFullVideoUrl {
              url
            }
          }
        }
      }
    `
  )
  return { secondaryHeroImage, heroVideo }
}
